import axios from 'axios'
import appconst from './appconst'
import swal from 'sweetalert'
import store from '../store'
import { handleAuthenticationFailure } from '../auth/authenticationFailure'
import {
  handleUnauthorizedResponse,
  prepareAuthenticatedRequest
} from '../auth/requestAuthentication'

const ajax = axios.create({
  baseURL: appconst.remoteServiceBaseUrl,
  timeout: 30000,
  withCredentials: true
})

const failAuthentication = () => handleAuthenticationFailure({
  clear: () => store.commit('unsetToken'),
  navigate: () => {
    if (window.location.pathname !== '/login') window.location.replace('/login')
  }
})

ajax.interceptors.request.use(
  async config => {
    config.headers.common[
      '.AspNetCore.Culture'
    ] = window.abp.utils.getCookieValue('.AspNetCore.Culture')
    // 首先从token解析，然后从URL，然后是header，然后是cookie
    config.headers.common[
      'Abp.TenantId'
    ] = window.abp.multiTenancy.getTenantIdCookie()

    try {
      return await prepareAuthenticatedRequest(config, {
        readAuthentication: () => store.commit('readToken'),
        isUpload: () => false,
        isTokenExpired: () => store.getters.isTokenExpired,
        getRefreshToken: () => store.getters.refreshToken,
        getAccessToken: () => store.getters.token,
        refresh: () => store.dispatch('refreshToken')
      })
    } catch (error) {
      await failAuthentication()
      throw error
    }
  },
  function(error) {
    return Promise.reject(error)
  }
)
ajax.interceptors.response.use(
  respon => {
    return respon
  },
  async error => {
    if (error.response && error.response.status === 401) {
      return handleUnauthorizedResponse(error, {
        getRefreshToken: () => store.getters.refreshToken,
        getAccessToken: () => store.getters.token,
        refresh: () => store.dispatch('refreshToken'),
        replay: config => ajax(config),
        failAuthentication
      })
    }

    if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message &&
      error.response.data.error.details
    ) {
      swal({
        title: error.response.data.error.message,
        text: error.response.data.error.details,
        icon: 'error'
      })
    } else if (
      !!error.response &&
      !!error.response.data.error &&
      !!error.response.data.error.message
    ) {
      swal({
        title: `${window.abp.localization.localize('Error')}: ${
          error.response.data.error.status
        }`,
        text: error.response.data.error.message,
        icon: 'error'
      })
    } else if (!error.response) {
      swal({
        title: window.abp.localization.localize('UnknownError'),
        icon: 'error'
      })
    }
    console.error(error)
    return Promise.reject(error)
  }
)
export default ajax



// WEBPACK FOOTER //
// ./src/utiltools/ajax.js